<script lang="ts">
	import type { FundingRateInterval } from '$lib/types/market';
	import GradientBorder from '$lib/util/GradientBorder.svelte';
	import { fundingRateInterval } from '../store';
	export let interval: FundingRateInterval;

	function setFundingRateInterval(newRange: FundingRateInterval) {
		$fundingRateInterval = newRange;
	}
</script>

{#if $fundingRateInterval == interval}
	<GradientBorder
		gradient="bg-fx-gradient-6"
		paddingClass="p-px"
		borderRadius="rounded-md"
		outerClassList=" w-full h-full"
		innerClassList="flex justify-center items-center w-full h-full"
	>
		<div
			class="px-1 py-0.5 cursor-pointer hover:bg-fx-grey-700 rounded-md text-fx-grey-100 text-xs"
		>
			{interval}
		</div>
	</GradientBorder>
{:else}
	<div class="p-px">
		<button
			class="px-1 py-0.5 cursor-pointer hover:bg-fx-grey-700 rounded text-fx-grey-300 text-xs"
			on:click={() => setFundingRateInterval(interval)}
		>
			{interval}
		</button>
	</div>
{/if}
